// Segment 7 — The Exchange
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const Segment7 = () => (
  <div>
    <h1 className="text-4xl md:text-5xl font-bold text-ink mb-8 leading-tight">The Exchange</h1>

    <p className="text-2xl md:text-3xl text-ink mb-12 leading-snug">
      Post one prompt from your session.
    </p>

    <Link
      to="/exchange"
      data-testid="exchange-go-btn"
      className="inline-flex items-center gap-3 px-8 py-4 bg-brand-orange text-white rounded-full font-bold text-lg hover:bg-brand-orange-hover transition-colors"
    >
      Go to the Exchange
      <ArrowRight size={20} strokeWidth={2.5} />
    </Link>
  </div>
);

export default Segment7;
